import React from 'react';

import classNames from 'classnames';

export interface IModalHeaderProps {
    children: React.ReactNode;
    className?: string;
}

export const ModalHeader = (props: IModalHeaderProps): JSX.Element => {
    const className: string = classNames(
        'modal__header',
        props.className,
    );

    return <div className={className}>{props.children}</div>;
};
